export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43088725278791:1',
  premium: 'https://www.compradigitalya.com/cart/43088729768007:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/bAGtj4mBXNm29iBHqbjDXt/ChatGPT_Image_13_ago_2026,_06_10_32_p.m..png'

export const testimonials = [
  {
    initials: 'SC',
    name: 'Sofía C.',
    place: 'Buenos Aires, Argentina · 34 años · Trabaja en oficina',
    text: 'Pasé años con la espalda y la cadera rígidas sin saber por dónde empezar. Con este programa tuve una guía clara desde el primer día: qué hacer, cuánto tiempo y cuándo avanzar. En pocas semanas ya notaba la diferencia al levantarme de la cama.',
  },
  {
    initials: 'JM',
    name: 'Jorge M.',
    place: 'Mendoza, Argentina · 51 años · Empleado administrativo',
    text: 'Tengo 51 años y creía que mi rigidez ya no tenía solución. Empecé con 10 minutos al día y hoy hago sesiones de 20 minutos sin ningún problema. El calendario 365 fue clave para no abandonar. Ojalá lo hubiera tenido antes.',
  },
  {
    initials: 'MP',
    name: 'Micaela P.',
    place: 'Córdoba, Argentina · 29 años · Va al gimnasio 4 veces por semana',
    text: 'Entrenaba fuerza pero la sentadilla profunda me era imposible por el tobillo. Con el Tomo 3 y el bono de gimnasio armé mi rutina pre-entreno y en 6 semanas mejoré el rango muchísimo. Ahora entreno sin molestias en la rodilla.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Movilidad desde Cero',
    period: 'Para empezar sin experiencia previa',
    content: [
      'Ejercicios para cuello, hombros, columna, cadera, rodillas y tobillos.',
      'Más de 30 ejercicios con posición exacta y errores frecuentes.',
      'Rutinas de 10, 15 y 20 minutos para casa y gimnasio.',
      'Programa de 4 semanas con checklist de progresión.',
    ],
  },
  {
    icon: '📗',
    name: 'Columna, Espalda y Hombros',
    period: 'Para liberar el tren superior',
    content: [
      'Columna cervical, torácica y lumbar cubiertas en profundidad.',
      'Hombros y escápulas: rotación, elevación y control completo.',
      'Rutinas para espalda rígida y para personas que trabajan sentadas.',
      'Programa de 4 semanas con progresión por nivel.',
    ],
  },
  {
    icon: '📙',
    name: 'Cadera y Piernas',
    period: 'Para liberar la cadena inferior',
    content: [
      '90/90, Frog Rock, Hip Switches, Couch Stretch y más.',
      'Tobillo, rodilla, isquiotibiales y aductores cubiertos.',
      'Movilidad aplicada directamente a la sentadilla y las zancadas.',
      'Programa de 4 semanas con test semanal de tobillo.',
    ],
  },
  {
    icon: '📕',
    name: 'Flexibilidad y Movilidad Activa',
    period: 'Para ganar control real del rango',
    content: [
      'Flexibilidad dinámica, estática y movilidad activa integradas.',
      'Rutinas de 15, 20, 25 y 30 minutos completamente armadas.',
      'Transiciones de suelo y control del movimiento avanzado.',
      'Programa semanas 13 a 16 con checklist avanzado.',
    ],
  },
  {
    icon: '📓',
    name: 'Programa Anual',
    period: 'Para los 12 meses completos',
    content: [
      'Qué trabajar, cuánto tiempo y qué nivel cada mes.',
      'Tests de movilidad al inicio, a mitad y al final del año.',
      'Registro mensual de progreso con tabla comparativa.',
      'Guía de adaptación para semanas difíciles.',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '⚡',
    'Movilidad Express',
    'Rutinas de 5, 7, 10 y 15 minutos para cada momento del día. Para los días donde no tenés tiempo: si tenés 5 minutos, tenés una sesión completa lista para hacer.',
    '$12.000',
  ],
  [
    '02',
    '💻',
    'Movilidad para Personas que Trabajan Sentadas',
    'Rutinas específicas para los efectos de pasar muchas horas en silla. Cuello, hombros, espalda, cadera y piernas. Para hacer durante el trabajo o al llegar a casa.',
    '$12.000',
  ],
  [
    '03',
    '🏋️',
    'Movilidad para el Gimnasio',
    'Rutinas pre y post entrenamiento organizadas por ejercicio y por zona. Mejora la técnica en sentadilla, peso muerto, press, dominadas y remo.',
    '$14.000',
  ],
  [
    '04',
    '🏠',
    'Movilidad en Casa',
    'Programa completo sin máquinas: pared, silla, toalla, almohadón y piso. Rutinas de 10, 15, 20 y 30 minutos por nivel: principiante, intermedio y avanzado.',
    '$12.000',
  ],
  [
    '05',
    '📅',
    'Calendario 365 Días',
    'Un año completo organizado semana a semana. Cada día dice qué hacer, cuánto tiempo, qué nivel y cuándo descansar. Cero decisiones, cero excusas.',
    '$10.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si nunca hice movilidad antes?',
    'Sí. El Tomo 1 está diseñado para personas que empiezan desde cero. Cada ejercicio tiene posición exacta, ejecución paso a paso y versión simplificada para principiantes. No hace falta ningún conocimiento previo.',
  ],
  [
    '¿Cómo recibo el material?',
    'Después de tu compra recibís un correo con el enlace de descarga en menos de 5 minutos. Todo es PDF, compatible con celular, tablet y computadora. El acceso no vence.',
  ],
  [
    '¿La garantía es real?',
    'Sí. Tenés 7 días para revisar todo el material. Si no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos el dinero. Sin vueltas ni preguntas.',
  ],
  [
    '¿Qué necesito para empezar?',
    'Solo necesitás un celular o computadora y un espacio de 2 metros de largo. La mayoría de los ejercicios no requieren ningún equipamiento.',
  ],
  [
    '¿Sirve para alguien con mucha rigidez?',
    'Sí. Hay un programa específico para personas muy rígidas que empieza con rutinas de 10 minutos y rangos mínimos. La progresión está pensada para cualquier punto de partida.',
  ],
  [
    '¿Está pensado para Argentina?',
    'Sí. El material está en español argentino, el pago es por Mercado Pago en pesos y los PDF se pueden imprimir en tamaño A4.',
  ],
  [
    '¿Cuánto tiempo por día necesito?',
    'Con 10 minutos por día ya avanzás. Las rutinas van de 5 a 30 minutos, así que podés elegir según el día que tengas. El Calendario 365 te indica qué hacer cada día para que nunca tengas que improvisar.',
  ],
  [
    '¿En cuánto tiempo voy a notar resultados?',
    'La mayoría siente menos rigidez en las primeras 2 semanas y ve cambios de rango medibles entre la semana 4 y la 8. Los tests de movilidad incluidos te permiten comprobar tu progreso con números, no con sensaciones.',
  ],
  [
    '¿Sirve si tengo más de 50 años?',
    'Sí. Los ejercicios tienen versiones con silla, pared y apoyos, y la progresión arranca desde rangos mínimos. Muchas de las personas que usan el sistema tienen entre 45 y 60 años.',
  ],
  [
    '¿Sirve si ya entreno en el gimnasio?',
    'Sí, y suma mucho. El Bono 03 tiene rutinas pre y post entrenamiento por ejercicio, y el Tomo 3 trabaja la movilidad de cadera y tobillo que necesitás para sentadilla, peso muerto y zancadas.',
  ],
] as const

export const recentPurchases = [
  ['Sofía C.', 'Buenos Aires', 'Combo Completo Movilidad y Flexibilidad'],
  ['Laura V.', 'Rosario', 'Combo Completo + Sistema Cuerpo Flexible'],
  ['Jorge M.', 'Mendoza', 'Combo Completo Movilidad y Flexibilidad'],
  ['Micaela P.', 'Córdoba', 'Combo Completo + Sistema Cuerpo Flexible'],
  ['Diego A.', 'La Plata', 'Combo Completo Movilidad y Flexibilidad'],
  ['Valeria T.', 'Mar del Plata', 'Combo Completo + Sistema Cuerpo Flexible'],
  ['Nicolás B.', 'Salta', 'Combo Completo Movilidad y Flexibilidad'],
  ['Romina L.', 'Neuquén', 'Combo Completo Movilidad y Flexibilidad'],
  ['Emiliano C.', 'San Miguel de Tucumán', 'Combo Completo + Sistema Cuerpo Flexible'],
  ['Gabriela F.', 'Bahía Blanca', 'Combo Completo Movilidad y Flexibilidad'],
] as const
